import { render, staticRenderFns } from "./Lease-Dashboard.vue?vue&type=template&id=0b82e901&"
import script from "./Lease-Dashboard.vue?vue&type=script&lang=ts&"
export * from "./Lease-Dashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports